import Cookies from 'js-cookie'
const tokenKey = 'TipDM-Login-Token'
const randKey = 'randKey'
import { Message } from 'element-ui'
import store from '../store'

export function getToken() {
    let accessToken = Cookies.get(tokenKey);
    return accessToken;
}

export function setToken(item) {
    let expiresTime = new Date(new Date().getTime() + (item.expires_in * 1000))
    Cookies.set(tokenKey, item.access_token, {expires: expiresTime})
}

export function removeToken() {
    Cookies.remove(tokenKey)
}

export function setUsername(username) {
    Cookies.set(userKey, username)
}

export function getUsername() {
    let username = Cookies.get(userKey)
    return username;
}

export function setRandKey(id) {
    Cookies.set(randKey, id)
}

export function getRandKey() {
    let rand = Cookies.get(randKey)
    return rand;
}

export function resetLogin() {
    Message({
        message: '当前会话已超时，请重新登录！',
        type: 'error',
        duration: 1 * 1000
    })
    setTimeout(()=> {
        removeToken();
        store.replaceState({});
        window.location.href = `${window.location.origin}/logout`;
    }, 1500)
}

